<template>
  <div class="box">
    <OperationBoxComponent :actions="actions" :filters="filters" />
    <DepartmentListComponet :page-data="pageData" :handle-remove="remove" v-if="pageData.items" @onItemEdit="edit" @onPageChanged="onPageChanged" />
    <el-dialog title="编辑单位" :visible.sync="showEditDialog" width="30%" :close-on-click-modal="false">
      <el-form :model="formData">
        <el-form-item label="所属片区" prop="area_id" label-width="120px" :rules="[{ required: true, message: '片区不能为空'}]">
          <el-col :span="6">
            <el-select style="min-width: 200px" v-model="formData.area_id" filterable placeholder="请选择">
              <el-option label="请选择" :value="0"></el-option>
              <el-option
                v-for="item in areaList"
                :key="item.id"
                :label="item.name"
                :value="item.id"/>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="单位名称" label-width="120px" :rules="[{ required: true, message: '名称不能为空'}]">
          <el-input v-model="formData.name" maxlength="30" placeholder="不超过30个字" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditDialog = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OperationBoxComponent from '../../../components/common/OperationBoxComponent'
import {MilkRequestUtil} from '../../../utils/MilkRequestUtil'
import DepartmentListComponet from '../../../components/department/DepartmentListComponet'
export default {
  name: 'MilkDepartmentListPage',
  components: { DepartmentListComponet, OperationBoxComponent },
  data () {
    return {
      actions: [
        { title: '', icon: 'el-icon-refresh', type: 'button', theme: 'primary', action: this.updateList },
        { title: '添加单位', type: 'button', theme: 'success', action: this.edit },
        {
          title: '所属片区',
          type: 'select',
          filterable: true,
          action: this.onAreaChange,
          options: () => {
            let items = []
            for (let i in this.areaList) {
              let item = this.areaList[i]
              items.push({
                title: item.name,
                value: item.id
              })
            }
            return items
          }
        }
      ],
      filters: [{
        searchValue: '',
        type: 'name',
        title: '单位名称',
        options: [{
          title: '单位名称',
          value: 'name'
        }],
        action: this.onFilterChange
      }],
      pageData: {items: []},
      areaList: [],
      formData: {id: 0, area_id: 0, name: ''},
      showEditDialog: false,
      queryParam: {
        area_id: 0,
        page: 1,
        pageSize: 25
      }
    }
  },
  mounted () {
    this.updateList()
    this.loadAreaList()
  },
  methods: {
    loadAreaList () {
      let that = this
      MilkRequestUtil.queryAreaList({queryParam: {pageSize: 1000}}, function (response) {
        that.areaList = response.items
      })
    },
    onAreaChange (item) {
      this.queryParam.page = 1
      this.queryParam.area_id = parseInt(item.selectValue)
      this.updateList()
    },
    edit (data) {
      this.showEditDialog = true
      if (data.id) {
        this.formData = JSON.parse(JSON.stringify(data))
      } else {
        this.formData = {id: 0, title: ''}
      }
    },
    save () {
      let that = this
      MilkRequestUtil.saveDepartment(this.formData, function (response) {
        if (response.id) {
          that.updateList()
          that.showEditDialog = false
        }
      })
    },
    remove (id) {
      let that = this
      MilkRequestUtil.removeDepartment(id, () => { that.updateList() })
    },
    onFilterChange (item) {
      this.queryParam.page = 1
      this.queryParam.type = item.type
      this.queryParam.keywords = item.searchValue
      this.updateList()
    },
    updateList () {
      let that = this
      this.pageData = {}
      MilkRequestUtil.queryDepartmentList({queryParam: this.queryParam}, function (response) {
        if (response) {
          that.pageData = response
        }
      })
    },
    onPageChanged (page) {
      this.queryParam.page = page
      this.updateList()
    }
  }
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/milk/department/MilkDepartmentListPage.vue